export const GRAPH = "/graph";
export const LOGIN = "/login";
export const CONTACTS = "/contacts";
